import ChartsDemo from "./charts-demo";

export default ChartsDemo;